/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Heading1, Paragraph } from '@motili/ui';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import { useAppSelector } from '../../../common/redux/hooks';
import GetStartedForm from './GetStartedForm';

export default function GetStarted(): ReactElement {
    const starterInfo = useAppSelector(
        ({ contractorRegistration }) => contractorRegistration.starterInfo
    );

    return (
        <CenteredContainer>
            <Heading1>Let's Get Started</Heading1>
            <Paragraph>
                Please enter your name, email address and phone number. The
                email address and phone number should be the main number and
                email that we will use to contact you.
            </Paragraph>
            <GetStartedForm starterInfo={starterInfo} />
        </CenteredContainer>
    );
}
